module.exports = __webpack_public_path__ + "img/adhesivo_de_recubrimientos_ceramicos.50f12d96.png";